import { isArray, get } from 'lodash';

const capralNameSpaces = ['CAPRAL', 'ALVARO'];
const coppNameSpaces = ['COPP'];
const trtNameSpaces = ['TRT'];

export default {
  computed: {
    loggedInUserData() {
      return this.$store.getters.userData;
    },
    amISystemAdmin() {
      const { type: loginType } = this.loggedInUserData;
      return loginType === 'SYSTEM_ADMIN';
    },
    amIAdmin() {
      const { type: loginType } = this.loggedInUserData;
      return loginType === 'ADMIN';
    },
    currentUserId() {
      const id = this.$store.getters.userData.id || 0;
      return id.toString();
    },
    impersonating() {
      return this.$store.getters.impersonating;
    },
    companyNameSpace() {
      return get(this.loggedInUserData, 'company.namespace', '');
    },
    companyMetadata() {
      return get(this.loggedInUserData, 'company.metadata', {});
    },
    isCapralConfig() {
      return capralNameSpaces.indexOf(this.companyNameSpace) > -1;
    },
    isPrambananConfig() {
      const isPrambanan = get(this.companyMetadata, 'is_prambanan', false);
      return isPrambanan;
    },
    isCOPPConfig() {
      return coppNameSpaces.indexOf(this.companyNameSpace) > -1;
    },
    isTRTConfig() {
      return trtNameSpaces.indexOf(this.companyNameSpace) > -1;
    },
  },
  watch: {
    impersonating(newValue) {
      this.$socket.emit('authorize', this.$store.getters.token);
      if (newValue) {
        this.$router.push('/');
      }
      this.$store.dispatch('notifications/LOAD_DATA');
      this.sendSelfMessage('reload', {
        destination: '/',
      });
    },
  },
  methods: {
    amIGreater(user) {
      const { type: loginType } = this.loggedInUserData;
      if (loginType === 'SYSTEM_ADMIN') {
        if (user.type === 'ADMIN') {
          return true;
        } else if (user.type === 'DEFAULT') {
          return true;
        }
      } else if (loginType === 'ADMIN') {
        if (user.type === 'DEFAULT') {
          return true;
        }
      }
      return false;
    },
    isMyCompany(companyId = -1) {
      const { _companyIds: companyIds } = this.loggedInUserData.company;
      if (!isArray(companyIds)) {
        return false;
      }
      return companyIds
        .map(c => c.toString())
        .indexOf(companyId.toString()) > -1;
    },
    amISuperior(user) {
      const userCompany = user.company || {};
      const oneCompany = this.isMyCompany(userCompany.id);
      const greaterLevel = this.amIGreater(user);

      if (this.amISystemAdmin && greaterLevel) {
        return true;
      } else if (greaterLevel && oneCompany) {
        return true;
      }

      return false;
    },
    canICreateUser(companyId) {
      if (this.amISystemAdmin) {
        return true;
      } else if (this.isMyCompany(companyId) && this.amIAdmin) {
        return true;
      }
      return false;
    },
    iHaveAccess(key) {
      const userAccess = this.$store.getters.userAccess || {};
      return get(userAccess, key);
    },
    startImpersonate(userId) {
      this.$socket.emit('deauthorize');
      this.$store.dispatch('IMPERSONATE', userId);
    },
    stopImpersonate() {
      this.$socket.emit('deauthorize');
      this.$store.dispatch('STOP_IMPERSONATE');
    },
    sendSelfMessage(action, data) {
      this.$socket.emit('self_message', {
        browserId: this.$store.getters.browserId,
        payloads: { action, data },
      });
    },
    logout() {
      this.$socket.emit('deauthorize');
      this.$store.dispatch('REMOVE_LOGIN_STATE').then(() => {
        this.sendSelfMessage('logout');
        this.$router.push('/login');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/user.js